// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3GbwK","title":"InfoRow_title__2Hbfq"};